module.exports = __webpack_public_path__ + "img/icon5.06d0c09e.jpg";